<template>
  <div class="case-disease-icon-page">
    <div class="icon-container row-block">
      <div :style="{ flex: 1 }"></div>
      <div v-if="paths" class="img-container center-block">
        <img :src="iconSrc" alt="">
        <div class="count-container">
          <borCor
            v-if="!disabled"
            :type="borCorType"
            :background="'white'"
            :border="'#707070'"
            :radius="'0px'"
            :blockStyle="{
              padding: '6px 8px'
            }"
          >
            <div slot="trigger">
              <div class="count center-block">{{ paths.length - 1 > 0 ? paths.length - 1 : '' }}</div>
            </div>
            <div class="content col-block" slot="content">
              <div class="text" :class="{ nodes: paths.length }" v-html="text"></div>
              <template v-if="paths.length">
                <div :style="{ height: '5px' }"></div>
                <div class="node-container col-block">
                  <div class="dash-line"></div>
                  <div class="node-block row-block stretch" v-for="(path, index) in paths" :key="index">
                    <div class="point-container">
                      <div class="point"></div>
                    </div>
                    <div><div :style="{ width: '5px' }"></div></div>
                    <div class="node-title" >{{ path.name }}</div>
                    <div><div :style="{ width: '5px' }"></div></div>
                    <div class="link-container">
                      <a class="link" :href="'https://hpo.jax.org/app/browse/term/' + path.id" target="_blank">
                        <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                      </a>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </template>
            </div>
          </borCor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import borCor from '../tool/borCor'

export default {
  components: {
    borCor
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => true
    },
    paths: {
      type: Array,
      default: () => null
    },
    borCorType: {
      type: String,
      default: () => 'bottom'
    }
  },
  computed: {
    iconSrc () {
      if (this.paths.length === 0) {
        return require('../../assets/images/disease-icon-0.svg')
      } else if (this.paths.length === 1) {
        return require('../../assets/images/disease-icon-1.svg')
      } else {
        return require('../../assets/images/disease-icon-n.svg')
      }
    },
    text () {
      if (this.paths.length === 0) {
        return this.$t('COMPONENT.case.diseaseIcon.___text01')
      } else if (this.paths.length === 1) {
        return this.$t('COMPONENT.case.diseaseIcon.___text02')
      } else {
        return this.$t('COMPONENT.case.diseaseIcon.___text03', { length: this.paths.length - 1 })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/diseaseIcon.vue